import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "./AxiosInstance";


const initialState = {
  posts: [],
  status: "idle",
  error: null,
};

export const postData = createAsyncThunk(
  "posts/fetchPosts",
  async ({ url, FormDataDynamic }) => {
    try {
      const formData = new FormData();
      Object.keys(FormDataDynamic).forEach((key) => {
        formData.append(key, FormDataDynamic[key]);
      });

      const response = await axiosInstance.post(url, formData, {
        headers: {
          Accept: "*/*",
        },
      });

      return response.data;
    } catch (error) {
      console.error("Error fetching posts:", error);
      throw error;
    }
  }
);

const postsSlice = createSlice({
  name: "posts",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postData.pending, (state) => {
        state.status = "loading";
      })
      .addCase(postData.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.posts = action.payload;
      })
      .addCase(postData.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export default postsSlice.reducer;